module.exports = __webpack_public_path__ + "static/media/E3.3130adf7.jpg";